<template>
  <div id="life_residence-halls">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>

    <usc-intro>
      <p><i>Numerous choices of residence halls, suites and apartments are available to freshmen and undergraduates at the university through <a href="https://housing.usc.edu/" class="inline-hyperlink" target="_blank">USC Housing</a>. In addition, the university provides a listing service for <a href="https://nup.och101.com/" class="inline-hyperlink" target="_blank">off-campus housing</a>.</i></p>
    </usc-intro>
    <div class="body gutter-lg mb">
      <p>Freshman housing is designed to create communities where students live and study together, socialize over meals in our residential dining facilities and adjust to college life. Numerous programs and activities keep residents involved and help you make friends. </p>
      <p>Download the <a href="https://housing.usc.edu/index.php/form_categories/application-brochures/" class="inline-hyperlink" target="_blank">USC Housing “Living at USC for Freshmen” brochure</a> and check out the <a href="https://housing.usc.edu/index.php/interactive-map/" class="inline-hyperlink" target="_blank">interactive map</a> to explore your USC Housing options.</p>
      <p>It’s important to <a href="https://housing.usc.edu/index.php/the-importance-of-applying-early-3/" class="inline-hyperlink" target="_blank">apply early</a> as housing assignments are made on a first-come, first-served basis. Learn more about the <a href="https://housing.usc.edu/index.php/how-to-apply-for-residential-colleges-and-special-interest-communities/" class="inline-hyperlink" target="_blank">application process</a>.</p>
    </div>
    <usc-callout-link :url="this.calloutLinks[0].url" :urltext="this.calloutLinks[0].urltext"></usc-callout-link>
    <div class="body gutter-lg mb">
      <p><strong>Freshmen Residence Halls</strong></p>
      <ul>
        <li>Birnkrant Residential College</li>
        <li>Marks Tower</li>
        <li>New North Residential College</li>
        <li>Pardee Tower</li>
      </ul>
      <p><strong>Freshmen Suites</strong></p>
      <ul>
        <li>McCarthy Honors Residential College</li>
        <li>Parkside Arts & Humanities Residential College</li>
        <li>Parkside International Residential College</li>
      </ul>
      <p><strong></strong></p>
      <ul>
        <li>Cale and Irani Residential College</li>
        <li>Cardinal Gardens</li>
        <li>Parkside Apartments</li>
        <li>Webb Tower</li>
      </ul>
      <p><strong>Undergraduate Apartments</strong></p>
      <ul>
        <li>Annenberg House</li>
        <li>Cale and Irani Residential College</li>
        <li>Cardinal ’N Gold</li>
        <li>Cardinal Gardens</li>
        <li>Century</li>
        <li>Cowlings and Ilium Residential College</li>
        <li>La Sorbonne</li>
        <li>McClintock Apartments</li>
        <li>McMorrow Residential College</li>
        <li>Nemirovsky and Bohnett Residential College</li>
        <li>Parkside Apartments</li>
        <li>Troy Hall</li>
        <li>Webb Tower</li>
      </ul>
    </div>
    <div class="body gutter-lg mb">
      <img src="../../../static/living-at-usc-housing.jpg" alt="USC Housing Map" title="USC Housing Map" style="width: 100%;" />
    </div>
    <div class="body gutter-lg mb">
      <p><strong>Special-Interest Housing Communities</strong><br />USC’s special-interest housing communities bring students and faculty together to share living and learning experiences. They feature activities and programs, both formal and informal, that enhance and expand your university life. Check out your options for <a href="https://resed.usc.edu/residential-colleges/" class="inline-hyperlink" target="_blank">special-interest communities</a> and, if one or more seems right for you, be sure to indicate those communities on your housing application. Certain programs, such as Deans’ Halls, have specific eligibility requirements. Programs can fill quickly, so apply early and list the community you would like as your first choice on your housing application.</p>
      <p>All first-year commuter students are invited to join one of the freshmen residential colleges, which will help you form strong connections by participating in events organized by the resident assistants and faculty in residence. You’ll have the opportunity to become an integral member of the community through interactions with peers outside of the classroom setting. Commuter students should contact <a href="mailto:resed@usc.edu" class="inline-hyperlink" target="_blank">resed@usc.edu</a> for more information.<br /></p>
      <p><strong>Gender-Inclusive Housing</strong><br />In USC’s gender-inclusive apartments, students can live with roommates regardless of gender identity or biological sex. Traditional housing options that match roommates based on biological sex can prove unsafe and unwelcoming, particularly for LGBTQ+ individuals. The gender-inclusive housing option allows students to live in a safe and supportive environment. Gender-inclusive housing spaces are located in <a href="http://housing.usc.edu/index.php/buildings/cardinal-gardens/" class="inline-hyperlink" target="_blank">Cardinal Gardens</a> and <a href="http://housing.usc.edu/index.php/buildings/century/" class="inline-hyperlink" target="_blank">Century</a>.</p>
      <p>If you are interested in living in <a href="https://housing.usc.edu/index.php/section/gender-inclusive-housing/" class="inline-hyperlink" target="_blank">Gender-Inclusive Housing</a>, indicate this in the Special Interest section of the online application.</p>
    </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import VueTinySlider from 'vue-tiny-slider'
import CalloutLink from '@/components/CalloutLink'
import twoColumns from '@/components/TwoColumns'

export default {
  name: 'ResidenceHalls',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'tiny-slider': VueTinySlider,
    'usc-callout-link': CalloutLink,
    'usc-twoColumns': twoColumns
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'USC Housing',
        loResSrc: '../../../static/HeroImages/Marshall42.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall42.jpg'
      },
      slideIndex: 1,
      prevDisabled: true,
      nextDisabled: false,
      slides: [
        {
          image: '/static/Life_At_Marshall_Residence_Halls_1.jpg',
          alt: 'USC Campus Map',
          id: 0
        },
        {
          image: '/static/Life_At_Marshall_Residence_Halls_2.jpg',
          alt: 'Dorm Interior',
          id: 1
        },
        {
          image: '/static/Life_At_Marshall_Residence_Halls_3.jpg',
          alt: 'Dorm interior',
          id: 2
        }
      ],
      calloutLinks: [
        {
          title: 'For more information, visit',
          url: 'https://housingapp.usc.edu/StarRezPortalX/42845DE5/1/1/Welcome_to_USC_Housi-Welcome_to_the_USC_H',
          urltext: 'Reserve my Room today'
        }
      ]
    }
  },
  created () {
    this.$root.setPageHeader('LIFE@MARSHALL', 'Residence Halls, Apartments and Suites')
  },
  methods: {
    prevSlide () {
      if (this.slideIndex > 1) {
        this.slideIndex--
      } else {
        this.prevDisabled = true
      }
    },
    nextSlide () {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++
      } else {
        this.nextDisabled = true
      }
    }
  },

  computed: {
    totalSlides () {
      return this.slides.length
    }
  }
}
</script>

<style scoped lang="scss">
@import '~tiny-slider/src/tiny-slider';
  ul {
    margin-left: 1em;
  }
  li {
    margin-left: 1em;
    padding-left: 1em;
    list-style-type: disc;
  }
</style>



// WEBPACK FOOTER //
// src/pages/life-at-marshall/ResidenceHalls.vue